/**
 * Memoized formatters for admin dashboard performance optimization
 * Caches expensive Intl formatters to eliminate redundant creation
 */

// Cache maps for formatters - reused across all components
const currencyFormatters = new Map();

/**
 * Memoized currency formatter - drop-in replacement for apiClient.formatCurrency
 * @param {number} amount - Amount to format
 * @param {string} currency - Currency code (default: USD)
 * @param {string} locale - Locale (default: en-US)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currency = 'USD', locale = 'en-US') => {
  const key = `${locale}-${currency}`;
  
  // Check cache first
  if (!currencyFormatters.has(key)) {
    currencyFormatters.set(key, new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }));
  }
  
  return currencyFormatters.get(key).format(amount || 0);
};